"use client";

import Markdown from "@/utils/Markdown";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

export default function ServicesFaq(cluster: any) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <section className="md:py-16 pt-[3rem] bg-gray">
        <div className="flex flex-col items-center">
          <h3 className="text-center">{cluster?.title}</h3>
          <div>
            <Image
              src="/assets/icons/title-arrow.svg"
              alt="Logo"
              width={100}
              height={50}
            />
          </div>
        </div>
        <div className="mx-auto mb-24">
          <div className="pt-[60px] grid md:grid-cols-2 grid grid-cols-1 gap-6 ml-8 md:ml-0">
            {cluster?.faqs?.map((item: any, index: number) => (
              <div key={index} className="flex flex-col items-center">
                <div className="flex items-center items-baseline md:w-[60%]">
                  <Image
                    src="/assets/icons/arr-right.svg"
                    alt="Arrow Icon"
                    onClick={() => toggleQuestion(index)}
                    width={10}
                    height={10}
                    className={`mr-3 cursor-pointer transition-transform duration-300 ${activeIndex === index ? "rotate-90" : ""
                      }`}
                  />
                  <button
                    className="faq-questions text-left w-full"
                    onClick={() => toggleQuestion(index)}
                  >

                    {item.question}
                  </button>
                </div>

                {activeIndex === index && (
                  <div className="mt-2 pl-[25px] flex items-center md:w-[60%]">
                    <Markdown cls="bdy-txt-5">{item.answer}</Markdown>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center my-12">
          <Link href={cluster?.cta?.link} className="over:border-b-0">
            <button className="btn-primary">{cluster?.cta?.text}</button>
          </Link>
        </div>
      </section>
    </>
  );
}
